import { actions as session } from './session.actions';
import * as sessionMatchers from './session.matchers';
import { actions as router } from '../router';
import { STATES } from '../../constants';
import { SESSION_HEADERS } from '../../constants';
import { matchers } from '../http-request';
import { track, ERROR } from '@updater-core/lib/tracker';
import { filterStateForLogging } from '@updater-core/lib/logger';

// Auth headers can be present in the metadata of a request (i.e. the action)
const filterMetadata = filterStateForLogging(['client', 'access-token']);

export function SessionEpic($state, appShell) {
  'ngInject';

  return (action, { dispatch }) => {
    if (sessionMatchers.isReadSuccess(action)) {
      // user came to updater with an active session
      dispatch(session.set(getSetSessionPayload(action.meta.response)));

      // Handle explicit sign out, read errors or 401
    } else if (
      sessionMatchers.isDestroySuccess(action) ||
      sessionMatchers.isDestroyError(action) ||
      sessionMatchers.isReadError(action) ||
      matchers.isRequestResponseStatus.unauthorized(action)
    ) {
      dispatch(session.clear());

      const sessionState = appShell.interactors.session.getState();

      try {
        const filteredDetails = filterMetadata({
          message: 'User in Mover-App reaching unauthenticated clause',
          action, // to see which action errored
          sessionMetadata: sessionState?.sessionMetadata, // to determine if it is due to expiring session
        });
        track({
          object: 'session_epic',
          verb: ERROR,
          details: filteredDetails,
          // at this point, session state has been cleared, but do not want to lose this metadata.
          // we store this metadata directly in the session state and use it here.
          ...sessionState?.eventStreamAttributes,
        });
      } catch (ignore) {
        console.error(ignore);
      }

      appShell.interactors.session.actions.clearSession(sessionState);
      appShell.interactors.router.go('/sign-in');
      // Handle 403 - Forbidden Errors
    } else if (matchers.isRequestResponseStatus.forbidden(action)) {
      dispatch(router.stateGo(STATES.ERROR));
    }
  };
}

function getSetSessionPayload(response) {
  return {
    ...getRelationshipIds(response),
    ...getResponseHeaders(response, SESSION_HEADERS),
  };
}

function getRelationshipIds({ data }) {
  const { relationships } = data.data;

  return Object.keys(relationships).reduce((ret, key) => {
    const relationship = relationships[key];
    ret[`${key}_id`] = relationship.data.id;
    return ret;
  }, {});
}

// AngularJS $http response only provides a function to retrieve
// headers one-by-on.
export function getResponseHeaders(response, headers) {
  return headers.reduce((result, header) => {
    result[header] = response.headers(header);
    return result;
  }, {});
}
